import React, { Component } from 'react';
import filterOptions from './filterOptions.json';
import { addFilter, removeFilter, clearFilters } from './../../actions/scenarioCatalogue/filterAction';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class FilterSidebar extends Component {
//    constructor(props) {
//        super(props)
//    }
//
    updateFilter(name, event) {
        if (event.target.checked){
            this.props.dispatch(addFilter(name, event.target.value));
        }else {
            this.props.dispatch(removeFilter(name, event.target.value));
        }
    }

    render() {
        const capitalize = (word) => {
            return word.split("_").map((item) => {
                return `${item.charAt(0).toUpperCase()}${item.slice(1)}`;
            }).join(" ")
        }
        return (
            <div>
                <div className="sidenav" style={{ paddingTop: "0%" }}>
                    <header style={{ backgroundColor: "#464646" }}>
                        <div className="row">
                            <div className="col-md-8 text-center d-flex justify-content-center"></div>
                            <div className="col-md-4 text-center d-flex justify-content-center">
                                <button
                                    className="btn"
                                    onClick={this.props.handleToggle}
                                    style={{ backgroundColor: "#464646" }}
                                >
                                    <i style={{ stroke: "#B0FF44", strokeWidth: "2px" }} className="fa fa-filter"></i>
                                </button>
                            </div>
                        </div>
                    </header>
                    <div className="row">
                        <div className="col-md-8">
                            <h2 style={{ color: "#464646" }}>FILTERS</h2>
                        </div>
                        <div className="col-md-4">
                            <button
                                className="btn"
                                style={{ backgroundColor: "#FFFFFF", color: "red" }}
                                data-toggle="tooltip" data-placement="top" title="Clear All Filters"
                                onClick={ () => { this.props.dispatch(clearFilters()) } }
                            >
                                <i className="fa fa-times-circle"></i>
                            </button>
                        </div>
                    </div>
                    <hr/>
                    <ul style={{ padding : "0%", listStyleType: "none" }} >
                        {Object.keys(filterOptions).map((element, index) => {
                            return(
                                <li key={`filters-${index}`}>
                                    <button style={{ fontWeight: "bold" }}>{capitalize(element)}</button>
                                    <ul style={{ listStyleType: "none" }}>
                                        {filterOptions[element].map((subElement,subIndex) => {
                                            const checked = this.props.filters[element]
                                                        ? this.props.filters[element].includes(subElement.toString())
                                                        : false;
                                            return (<li key={`element-subElement-${subIndex}`}>
                            
                                                        <input
                                                            type="checkbox"
                                                            id={`element-subElement`}
                                                            value={subElement}
                                                            name={subElement}
                                                            checked={checked}
                                                            onChange={(event) => { this.updateFilter(element, event) }}
                                                        />
                                                        <label htmlFor={`element-subElement`} style={{ paddingLeft: "2%" }}>{subElement}</label>
                                                    </li>)
                                                    
                                        })}
                                    </ul>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )
    }
}
FilterSidebar.propTypes={
filters:PropTypes.string,
dispatch:PropTypes.string,
handleToggle:PropTypes.string,
}
FilterSidebar.defaultProps= {
filters:[],
dispatch:[],
handleToggle:[],
}

const mapStateToProps = (state) => {
    return {
        filters: state.filters.filters
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default connect(mapStateToProps)(FilterSidebar)
